<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Response from "@/router/views/master/employee/upload/response";
import { Helper } from "@/mixin/helper";
import {
  IMPORT_EMPLOYEE,
  GET_EMPLOYEE_UPLOAD_HISTORY,
} from "@/services/api/master/employees";

export default {
  page: {
    title: "Master",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Response,
  },
  apollo: {
    importHistories: {
      query: GET_EMPLOYEE_UPLOAD_HISTORY,
      variables() {
        return {
          filter: {
            model: "employee",
            orderBy: [JSON.stringify({ importOn: "desc" })],
          },
        };
      },
      result({ data, loading }) {
        if (loading) return;
        this.totalRows = data.importHistories.importHistories.length;
        this.filterOn = data.importHistories.importHistories;
      },
    },
  },
  mixins: [Helper],
  data() {
    return {
      importHistories: {
        importHistories: [],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      value: "",
      file: null,
      fileProp: {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      },
      showRemovedBtn: false,
      importResponse: false,
      responseData: {
        totalFailed: null,
        totalSuccess: null,
        totalData: null,
        errorFile: null,
        fileName: null,
        fileType: null,
      },
    };
  },
  computed: {
    /**
     * Total no. of records
     */

    rows() {
      return this.importHistories.importHistories.length;
    },

    title() {
      return "Unggah";
    },
    items() {
      return [
        {
          text: this.$t("menuitems.masterData.text"),
        },
        {
          text: this.$t("menuitems.masterData.list.employee"),
        },
        {
          text: "Unggah",
        },
      ];
    },
    historyUpload() {
      return [
        {
          key: "importOn",
          label: "Waktu",
          sortable: true,
        },
        {
          key: "filename",
          label: "Nama ",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "users.fullname",
          label: "Diunggah Oleh",
          sortable: true,
        },
      ];
    },
  },
  mounted() {
    this.$apollo.queries.importHistories.refetch();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    directTo() {
      this.$bvModal.hide("modal-template-download");
    },
    refreshData() {
      this.$apollo.queries.importHistories.refetch();
    },
    async fileChangeHandler(e) {
      const files = e.target.files;
      if (files.length == 0) return;
      this.file = files[0];
      this.fileProp.name = files[0].name;
      this.fileProp.size = (files[0].size / (1024 * 1024)).toFixed(2);

      const input = {
        filebase64: null,
        filename: files[0].name,
      };

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      input.filebase64 = (await toBase64(files[0])).split(",")[1];

      if (
        files[0].type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        files[0].type === "text/csv"
      ) {
        if (this.fileProp.size > 10) {
          this.fileProp.message = "Ukuran File Terlalu Besar";
          this.fileProp.error = true;
          return;
        }
        this.fileProp.error = false;
        this.showRemovedBtn = true;

        const param = [15, 25, 50, 70, 90, 100];
        for (let i = 0; i < param.length; i++) {
          setTimeout(() => {
            this.fileProp.sizeProgress = (
              (this.fileProp.size * param[i]) /
              100
            ).toFixed(2);
            this.fileProp.progressVal = param[i];
            if (param[i] === 100) {
              setTimeout(() => {
                this.$apollo
                  .mutate({
                    mutation: IMPORT_EMPLOYEE,
                    variables: {
                      input: input,
                    },
                  })
                  .then((response) => {
                    if (response.data.importEmployees.isSuccessful) {
                      this.importResponse = true;
                      this.responseData.totalData =
                        response.data.importEmployees.importEmployees.totalData;
                      this.responseData.totalFailed =
                        response.data.importEmployees.importEmployees.totalFailed;
                      this.responseData.totalSuccess =
                        response.data.importEmployees.importEmployees.totalSuccess;
                      this.responseData.errorFile =
                        response.data.importEmployees.importEmployees.errorFile;
                      this.responseData.fileName = files[0].name;
                      this.responseData.fileType = files[0].type;
                    } else {
                      if (
                        response.data.importEmployees.message ==
                        'Error: "Incorrect File Used."'
                      ) {
                        this.fileProp.message = "Template File Tidak Sesuai";
                        this.fileProp.error = true;
                      } else {
                        return this.$toast.warning(
                          response.data.importEmployees.message
                        );
                      }
                    }
                  });
              }, 1000);
            }
          }, i * 500);
        }
      } else {
        this.fileProp.message = "Jenis File Tidak Sesuai";
        this.fileProp.error = true;
      }
    },
    deleteFile() {
      this.importResponse = false;
      this.file = null;
      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      };
    },
  },
};
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p class="mb-4">Halaman unggah data karyawan.</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            v-b-modal.modal-history-upload
            variant="outline-primary"
            class="ms-3"
            @click="refreshData"
          >
            <i class="mc-fa icon-outline_file-text"></i> Riwayat Unggahan
          </b-button>
          <b-button
            @click="deleteFile"
            variant="primary"
            class="ms-2"
            v-if="importResponse"
          >
            <i class="mc-fa icon-outline_upload"></i> Unggah Lagi
          </b-button>
          <b-button
            @click="$router.push({ name: 'Master Employee' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="card" v-if="!importResponse">
      <div class="card-body">
        <div class="mc-upload d-flex justify-content-between">
          <div class="mc-upload__file">
            <div class="mc-upload__file-wrapper">
              <div class="mc-upload__file-area" v-if="fileProp.name == null">
                <input
                  id="inputfile"
                  ref="inputfile"
                  type="file"
                  @change="fileChangeHandler"
                  @drop="fileChangeHandler"
                  name="attachment"
                  class="mc-upload__file-area-input"
                  accept=".xlsx, .csv"
                />

                <div class="mc-upload__file-area-text">
                  <i class="mc-fa icon-outline_upload"></i>
                  <p>Pilih atau Taruh Berkas di sini</p>
                  <p>(Maksimal 10 MB)</p>
                </div>
              </div>

              <!-- <div
                  @click.stop="clearFileHandler"
                  class="c-file-input__remove js-file-input__remove"
                >
                  <span
                    class="
                      c-file-input__remove__icon
                      c-icon c-icon--remove-circle
                    "
                  >asd</span>
                  
                </div> -->

              <div
                :class="`mc-upload__file-result ${
                  fileProp.error ? 'mc-upload__file-result--error' : null
                }`"
                v-else
              >
                <div class="mc-upload__file-result-wrapper">
                  <i class="mc-fa icon-outline_file"></i>
                  <h4 class="mc-upload__file-result-status">
                    {{ fileProp.message }}
                  </h4>
                  <div
                    class="mc-upload__file-result-desc d-flex justify-content-between"
                  >
                    <span>{{ fileProp.name }}</span>
                    <span v-if="fileProp.error">
                      <!-- <i class="mc-fa icon-outline_refresh"></i> -->
                      <i
                        class="mc-fa icon-outline_trash-2"
                        @click="deleteFile"
                      ></i>
                      <i class="mc-fa icon-fill_alert-triangle"></i>
                    </span>
                  </div>
                  <div class="mc-upload__file-result-progress">
                    <div :style="`width: ${fileProp.progressVal}%`"></div>
                  </div>
                  <span class="mc-upload__file-result-filesize">
                    <span>{{ fileProp.sizeProgress }} MB / </span
                    >{{ fileProp.size }} MB
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-upload__info">
            <div class="mc-upload__info-wrapper">
              <h3 class="mc-upload__info-title">
                <i class="mc-fa icon-outline_book"></i> Panduan
              </h3>
              <ul class="mc-upload__info-list">
                <li>
                  <strong>Unduh Template</strong>
                  <p>
                    Kami memiliki ketentuan format berkas. Silahkan unduh
                    terlebih dahulu format berkas yang sudah kami sediakan
                  </p>
                  <b-button
                    variant="primary"
                    size="sm"
                    v-b-modal.modal-template-download
                    ><i class="mc-fa icon-outline_download"></i> Unduh
                    Template</b-button
                  >
                </li>
                <li>
                  <strong>Salin Data Anda</strong>
                  <p>
                    Gunakan microsoft excel, spreadsheet, atau program sejenis
                    lainnya untuk menyalin data anda. Pastikan pengisian data
                    sesuai dengan kolom yang sudah disediakan
                  </p>
                </li>
                <li>
                  <strong>Unggah Berkas</strong>
                  <p>
                    Setelah selesai, simpan berkas anda dengan ekstensi
                    <b>.csv</b> atau <b>.xlsx</b>. Kemudian unggah berkas
                    tersebut ke form samping
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Response
      v-else
      :totalFailed="responseData.totalFailed"
      :totalSuccess="responseData.totalSuccess"
      :totalData="responseData.totalData"
      :errorFile="responseData.errorFile"
      :fileName="responseData.fileName"
      :fileType="responseData.fileType"
    />

    <b-modal
      class="mc-modal"
      id="modal-history-upload"
      title="Riwayat Unggah"
      size="lg"
      centered
      scrollable
    >
      <div class="clearfix">
        <!-- Search -->
        <div class="float-end">
          <div class="mc-table-view">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-end"
            >
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>

      <!-- Table -->
      <div class="table-responsive my-3 border border-1">
        <b-table
          small
          show-empty
          :fields="historyUpload"
          :items="importHistories.importHistories"
          class="datatables"
          responsive="sm"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
        >
          <template #cell(importOn)="row">
            <p class="my-0">
              {{ momentDateShortMonth(row.value) }}
            </p>
            <p class="text-muted my-0">{{ momentTime(row.value) }}</p>
          </template>
          <template #cell(status)="data">
            <span
              class="mc-status mc-status--green"
              v-if="data.item.totalFailed === 0"
            >
              Berhasil
            </span>
            <span
              class="mc-status mc-status--red"
              v-else-if="data.item.totalSuccess === 0"
            >
              Gagal
            </span>
            <span
              class="mc-status mc-status--yellow"
              v-else-if="
                data.item.totalSuccess > 0 && data.item.totalFailed > 0
              "
            >
              Berhasil Sebagian
            </span>
          </template>
        </b-table>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Menampilkan
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              >
              </b-form-select>
              entri.
              <p>
                Menampilkan&nbsp;<strong>{{
                  totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0
                }}</strong
                >&nbsp;sampai&nbsp;<strong>{{
                  Math.min(totalRows, currentPage * perPage)
                }}</strong
                >&nbsp;dari&nbsp;<strong>{{ totalRows }}</strong
                >&nbsp;entri.
              </p>
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows == null ? rows : totalRows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <b-button variant="outline-primary" @click="cancel()">
              Tutup
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      class="mc-modal"
      id="modal-template-download"
      title="Unduh template"
      size="md"
      centered
      scrollable
    >
      <p>
        Template ini terikat dengan data yang sudah ada, Anda dapat mengunduh
        template bersamaan dengan data yang sudah ada.
      </p>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <b-button variant="outline-primary" @click="cancel()">
              Tutup
            </b-button>
            <a
              href="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/Import+Data+Karyawan.xlsx"
              target="_blank"
              class="btn btn-primary ms-2"
              @click="directTo()"
            >
              Template & Data
            </a>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
